import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'
import { HALF_DAY_TYPES } from 'modules/timeoff/store/models/Leave'

export interface LeaveInfo {
  half_day: string | null
  color: string
  name: string
  is_workable: boolean
  hours_amount: string | null
  hourly_start_time: string | null
  day_type: string
  type: string
}

interface ICalendarDay {
  [key: string]: any
  leaves: LeaveInfo[]
}

class CalendarDay extends Model<ICalendarDay> {
  static urlRoot() {
    return '/attendance/calendar'
  }

  constructor(attr: ICalendarDay = { leaves: [] }) {
    super(attr)
    makeObservable(this, {
      isWorkable: computed,
      workableHalfDay: computed,
    })
  }

  get isWorkable(): boolean {
    return this.get('is_laborable') && (!this.get('is_leave') || this.leaveHalfDay)
  }

  get leaveHalfDay(): string | null | undefined {
    return this.leaves.find((leave) => leave.half_day)?.half_day
  }

  get workableHalfDay(): string | null {
    if (!this.leaveHalfDay || !this.get('is_leave')) {
      return null
    }

    return this.leaveHalfDay === HALF_DAY_TYPES.end_of_day
      ? CompanyHoliday.HalfDayTypes.beginning_of_day
      : HALF_DAY_TYPES.end_of_day
  }

  get leaves(): LeaveInfo[] {
    return this.attributes.leaves
  }
}

export default CalendarDay
